import {useTranslation} from 'react-i18next';

import {Box, CardMedia, Grid, Typography} from '@mui/material';

import {bodyPdf, bodyPdfExtraLineHeight, pdfH1, pdfH3} from '../styles';

import cardImage from '../../../../assets/pdf/analysis_guide/page_two.png';

export const SecondPage = () => {
  const {t} = useTranslation('pdfDomain', {keyPrefix: 'analysisGuide.secondPage'});
  const {t: tr} = useTranslation('pdfDomain', {keyPrefix: 'analysisGuide.secondPage.bulletPoints'});

  const cardMediaStyle = {height: '200px', width: '700px', borderRadius: '16px'};

  return (
    <>
      <Grid container height={'350px'} p={5} justifyContent={'center'}>
        <Box width={'550px'}>
          <Typography variant='h1' sx={pdfH1} mb={2}>
            {t('pageTitle')}
          </Typography>
          <Typography sx={bodyPdf} mb={1}>
            {t('blockOne')}
          </Typography>
        </Box>
      </Grid>
      <Grid container justifyContent={'center'} mt={'-30px'}>
        <CardMedia component='img' image={cardImage} sx={cardMediaStyle} />
        <Grid container item width={'550px'} justifyContent={'space-between'} mt={5}>
          <Typography variant='h3' sx={pdfH3} mb={2}>
            {t('sectionTitle')}
          </Typography>
          <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('one')}</Typography>
          <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('two')}</Typography>
          <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('three')}</Typography>
          <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('four')}</Typography>
          <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('five')}</Typography>
          <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('six')}</Typography>
        </Grid>
      </Grid>
    </>
  );
};
